export async function api<T = any>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const response = await fetch(`/api${path}`, {
    ...options,
    headers: {
      ...(options.body instanceof FormData
        ? {}
        : { "Content-Type": "application/json" }),
      ...options.headers,
    },
  });
  if (!response.ok) {
    const data = await response
      .json()
      .catch(() => ({ error: `Request failed (${response.status})` }));
    throw new Error(data.error || "Request failed.");
  }
  return response.json();
}
export function save(path: string, value: unknown, method = "POST") {
  return api(path, { method, body: JSON.stringify(value) });
}
export async function upload(eventId: string, file: File, kind = "photo") {
  const body = new FormData();
  body.append("file", file);
  body.append("kind", kind);
  return api(`/admin/events/${eventId}/upload`, { method: "POST", body });
}
